import React from 'react';
import {Button, Card, CardActions, CardContent, CardMedia, makeStyles, Typography} from "@material-ui/core";
import diego from '../images/diego.jpg';
import TypeWriterEffect from "react-typewriter-effect";
import pdf from "../images/cv.pdf";



const About = ({title,dark,id}) => {
    const classes = useStyles();
    return (
       
             <div  className={classes.sectioncontent} id={id}>
               <Typography 
               style={{fontWeight:"bold",color:"#0c82ad"}}
               variant="h3">{"WELCOME"} 
               
               </Typography>
                <Card  className={classes.card}>
                    
                    <CardMedia  image={diego} className={classes.media}
                    title="picture"/>
                    <CardContent className={classes.cardcontent}>
                        <TypeWriterEffect 
                        text="Hi, I'm Diego Yañez"
                        textStyle={{
                            fontSize:"2rem",
                            fontWeight:"700px",
                            color:"black",
                            
                        }}
                        startDelay={100}
                        cursorColor="black"
                        typeSpeed={75}

                        />
                        <TypeWriterEffect 
                        text="and I am a Software Developer and Tester Analyst"
                        textStyle={{
                            fontSize:"1.2rem",
                            fontWeight:"500px",
                            color:"primary"}}
                        startDelay={2500}
                        cursorColor="black"
                        typeSpeed={75}

                        />
                        <Typography  variant="h6" className={classes.description} >
                        Knowledge of software development and testing;
                        incident life cycle (categorize / prioritize) and
                        Considerations for the quality of web and mobile systems.
                        
                        </Typography>
                    </CardContent>
                    <CardActions>
                        <Button variant="contained" className={classes.pdfbutton}>
                           <a href={pdf} download>
                            Download CV
                            </a> 
                        </Button>
                    </CardActions>
                </Card>
             </div>
        
    )
}

const useStyles = makeStyles((theme) => ({ 
    
    
    sectioncontent:{
        
        marginTop:theme.spacing(),
        color:"#fff",
        maxWidth:"80vw",
        margin:"0 auto",
        background:"#d4d5d6",
        
        
    },
    card:{
       background:"#efefef",
      height:"60vh",
      display:"flex",
      marginTop:theme.spacing(3),
      position:"relative",
      [theme.breakpoints.down("xs")]:{
        position:"center"
    },
    
    
      
    },
    media:{
        width:"250px",
        height:"auto",
        objectFit:"cover",
        borderRadius:"15px",
        margin:theme.spacing(4),
        [theme.breakpoints.down("xs")]:{
            width:"100%"
        },
        
    },
    cardcontent:{
       margin:theme.spacing(2),
       "& h6":{
          marginTop:theme.spacing(3),
          [theme.breakpoints.down("sm")]:{
            display:"none"
        },
       },
    },
    pdfbutton:{
        color:"#1eba8b",
        backgroundColor:"#87e8c8",
        position:"absolute",
        bottom:"1rem",
        right:"3rem",
          [theme.breakpoints.down("sm")]:{
              bottom:"1rem",
              right:"1rem"
          },

        padding:theme.spacing(3),
        "&:hover":{
            backgroundColor:"#333",
            
        },
        "& a":{
            color:"black",
            fontWeight:"600",
            textDecoration:"none",
            
        }
        
       
    },
    description:{
        color:"#6e6d6b"
    }
  }))

export default About;
